<div class="container">
  <div class="row min-vh-100 align-items-center justify-content-center">
    <div class="col-12 col-md-8 col-lg-6">
      <div class="card shadow-lg border-0 error-card">
        <div class="card-body text-center p-5">
          <!-- Icon d'erreur -->
          <div class="error-icon-wrapper mb-4">
            <div class="error-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="15" y1="9" x2="9" y2="15"></line>
                <line x1="9" y1="9" x2="15" y2="15"></line>
              </svg>
            </div>
          </div>

          <!-- Titre et message -->
          <h1 class="display-5 fw-bold text-danger mb-3">Activation échouée</h1>
          <p class="lead text-muted mb-4">
            Nous n'avons pas pu activer votre compte. Le lien d'activation est peut-être expiré ou invalide.
          </p>

          <!-- Raisons possibles -->
          <div class="alert alert-light border text-start mb-4">
            <h6 class="fw-bold mb-2">Raisons possibles :</h6>
            <ul class="mb-0 small text-muted">
              <li>Le lien d'activation a expiré</li>
              <li>Le lien a déjà été utilisé</li>
              <li>Le lien est invalide ou corrompu</li>
            </ul>
          </div>

          <!-- Boutons d'action -->
          <div class="d-grid gap-2 d-md-flex justify-content-md-center">
            <button class="btn btn-danger btn-lg px-4" (click)="resendActivation()">
              Renvoyer le lien
            </button>
            <button class="btn btn-outline-secondary btn-lg px-4" routerLink="/">
              Retour à l'accueil
            </button>
          </div>

          <!-- Message d'aide -->
          <div class="mt-4 pt-4 border-top">
            <p class="text-muted small mb-2">
              Besoin d'aide ?
            </p>
            <a href="mailto:support@referio.be" class="text-decoration-none">
              Contactez notre support
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>